<div>
  <div>
    <input
      #inputRef
      [id]="id"
      type="range"
      [step]="step"
      [name]="name"
      [max]="max"
      [min]="min"
      [value]="value"
      (input)="inputChange($event)"
      (change)="valueChange($event)"
      (touchstart)="touchStart($event)"
      (mousedown)="touchStart($event)"
    />
  </div>
</div>
